import type { StatusColorTone } from '@/styles/statusColors';

export const MENU_LABEL_MAX_LENGTH = 80;

export const MENU_LABEL_STATUS = {
  original: 'original',
  renamed: 'renamed',
  unsaved: 'unsaved',
} as const;

export type MenuLabelStatus = (typeof MENU_LABEL_STATUS)[keyof typeof MENU_LABEL_STATUS];

export const MENU_LABEL_FILTER = {
  all: 'all',
  renamed: 'renamed',
} as const;

export type MenuLabelFilter = (typeof MENU_LABEL_FILTER)[keyof typeof MENU_LABEL_FILTER];

export const MENU_LABEL_STATUS_BADGE: Record<
  MenuLabelStatus,
  { label: string; tone: StatusColorTone }
> = {
  original: { label: 'Original', tone: 'neutral' },
  renamed: { label: 'Renamed', tone: 'info' },
  unsaved: { label: 'Unsaved', tone: 'warning' },
};
